import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

// Style for the scroll to top button
const ScrollButton = styled.button`
  position: fixed;
  bottom: 40%;
  left:90%;
  width:70px;
  background-color: #ce8e04;
  color: white;
  border: none;
  border-radius: 50%;
  padding: 15px;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: ${(props) => (props.show ? '1' : '0')};
  transition: opacity 0.3s ease;

  &:hover {
    background-color: #d98a04;
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  }
@media (max-width: 480px) {
     bottom: 70%;
  left:80%;
  }`;

const Scroll = () => {
  const [showButton, setShowButton] = useState(false);

  // Check if the user has scrolled to the bottom
  const handleScroll = () => {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Show the button when user is near the bottom (adjust as needed)
    if (scrollTop + windowHeight >= documentHeight - 100) {
      setShowButton(true);
    } else {
      setShowButton(false);
    }
  };

  // Scroll to top of the page when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scroll
    });
  };

  // Add the scroll event listener when component mounts
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    // Cleanup event listener when component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div>
     
      {/* Scroll to Top Button */}
      <ScrollButton show={showButton} onClick={scrollToTop}>
        ↑
      </ScrollButton>
    </div>
  );
};

export default Scroll;
